define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "forms/register/register_login_form",
    "moment",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, FormErrorsBehavior, RegisterLoginForm, moment) {
    return Marionette.View.extend({
        el: '#content_layout',
        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
        },
        ui:{
            'submitBtn': '.btn-submit',
            'form': '#register_login_form'
        },
        events:{
            'click @ui.submitBtn': 'submit',
        },

        initialize: function(){
            this.bindUIElements();
            this.registerLoginForm = new RegisterLoginForm();
        },

        validateForm: function(){
            var that = this;

            this.triggerMethod('hide:errors');
            var formData = Backbone.Syphon.serialize(this);

            var form = this.registerLoginForm;
            form.set(formData);

            var errors = form.validate();
            var d = $.Deferred();

            if(!errors){
                return form.validateWithServer({
                    success: function(model, response){
                        //d.resolve();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }else{
                d.reject();
                this.triggerMethod('show:errors', errors);
            }
            return d.promise();
        },

        submit: function(e){
            const formData = Backbone.Syphon.serialize(this);
            const that = this;

            if(e) e.preventDefault();
            HoldOn.open({
                theme:"sk-fading-circle"
            });

            $.ajax({
                url: '/rest_register/validate_register_login',
                type: 'POST',
                data: formData,
                success: function(response){
                    that.ui.form.submit();
                },
                error: function(err){
                    var error = err.responseJSON;
                    that.triggerMethod('show:errors', error);
                    HoldOn.close();
                }
            });
        }
    });
});
